import { navigate } from "gatsby";
import React, { FC, useCallback, useState } from "react";

import { QS_QUERY_KEY } from "../../../constants/search";
import { useHeaderMenu } from "../../../hooks/use-header-menu";
import { getLocalizedPath } from "../../../utils/pages";
import { Button } from "../../buttons/button";
import { Input } from "../../forms";
import { Icon } from "../../icon";

const SEARCH_INPUT_ID = "header-search-input";

export const SearchForm: FC = () => {
  const [inputValue, setInputValue] = useState("");
  const {
    labels,
    headerMenu: { node_locale },
    setItemPanelExpanded,
  } = useHeaderMenu();

  const handleOnClick = useCallback(() => {
    setItemPanelExpanded(false);
    navigate(getLocalizedPath(`/search?${QS_QUERY_KEY}=${inputValue}`, node_locale));
  }, [inputValue, node_locale, setItemPanelExpanded]);

  const resetSearch = useCallback(() => {
    setInputValue("");
    try {
      // TODO see if we can make it work with a ref
      document.getElementById(SEARCH_INPUT_ID)?.focus();
    } catch (e) {
      console.error(e);
    }
  }, [setInputValue]);

  return (
    <div
      className="flex gap-4 w-full items-center"
      onKeyDown={(e) => {
        if (e.code === "Enter") handleOnClick();
      }}
    >
      <Input
        value={inputValue}
        id={SEARCH_INPUT_ID}
        onChange={(e) => setInputValue(e.target.value)}
        placeholder={labels["header-menu-search-placeholder"] ?? undefined}
        className="flex-grow"
        endDecoration={
          inputValue ? (
            <Icon icon="close" size={25} onClick={resetSearch} />
          ) : (
            <Icon icon="search" size={25} />
          )
        }
      />
      <Button variant="primary" size="sm" onClick={handleOnClick}>
        {labels["header-menu-search-submit"]}
      </Button>
    </div>
  );
};
